import { createContext, useContext } from 'react';
var TabsContext = createContext(void 0);
var useTabs = function useTabs() {
  var context = useContext(TabsContext);
  if (!context) throw new Error("Component must be used within <Tabs>");
  return context;
};
export { TabsContext, useTabs };